import React, { useState } from 'react';
import { Button, Container, NotFoundBlock, Paper } from 'library';
import { NumberParam, useQueryParam } from 'use-query-params';
import { browserWindow } from 'utils/window';

import AmountCalculatorHero from './components/AmountCalculatorHero/AmountCalculatorHero';
import AmountCalculatorNoTable from './components/AmountCalculatorNoTable/AmountCalculatorNoTable';
import useAmountCalculator from './hooks/useAmountCalculator';

// import AmountCalculator from './components/AmountCalculator/AmountCalculator';

const AmountCalculatorController = ({ heading, formHeading, subheading, blockImage }) => {
  const [estimatedHomeValue, setEstimatedHomeValue] = useQueryParam('home_value', NumberParam);
  const [investmentAmount, setInvestmentAmount] = useState(0);
  const {
    minMax,
    error,
    isFetchingData,
    // scenarios,
  } = useAmountCalculator(estimatedHomeValue, investmentAmount, setInvestmentAmount);

  const onEstimatedHomeValueSubmit = (data) => {
    setEstimatedHomeValue(data.estimatedHomeValue);
  };

  const onReload = () => {
    browserWindow.location.reload();
  };
  return (
    <>
      <AmountCalculatorHero
        estimatedHomeValue={estimatedHomeValue}
        omitMobileImage={!!estimatedHomeValue}
        onSubmit={onEstimatedHomeValueSubmit}
        heading={heading}
        subheading={subheading}
        formHeading={formHeading}
        backgroundImage={blockImage?.localFile?.childImageSharp?.fluid}
        isFetchingData={isFetchingData}
      />
      {estimatedHomeValue ? (
        error ? (
          <Paper theme="medium">
            <Container row justify="center" space={6}>
              <Paper pad={3}>
                <NotFoundBlock error="" title="Looks like we’re having some trouble fetching this data.">
                  We apologize for this issue, please try again soon.
                  <br />
                  <div>
                    <Button onClick={onReload}> Try again </Button>
                    <br />
                    <a href="https://hometap.com/how-it-works/">See how a Hometap Investment works.</a>
                  </div>
                </NotFoundBlock>
              </Paper>
            </Container>
          </Paper>
        ) : (
          // <AmountCalculator
          //   min={minMax.min}
          //   max={minMax.max}
          //   scenarios={scenarios}
          //   investmentAmount={investmentAmount}
          //   setInvestmentAmount={setInvestmentAmount}
          //   isFetchingData={isFetchingData}
          // />
          <AmountCalculatorNoTable max={minMax.max} />
        )
      ) : (
        <div style={{ marginTop: '75px', borderBottom: '1px solid #dddddd' }} />

        // <div className="Placeholder" style={{ height: '45vh', background: '#F6F6F6' }}>
        //   <Paper theme="medium"></Paper>
        // </div>
      )}
    </>
  );
};

export default AmountCalculatorController;
